import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ContextAwareNavbar } from "@/components/layout/ContextAwareNavbar";
import { Footer } from "@/components/layout/Footer";
import { Hero } from "@/components/sections/Hero";
import { Pillars } from "@/components/sections/Pillars";
import { HowItWorks } from "@/components/sections/HowItWorks";
import { Stats } from "@/components/sections/Stats";
import { CTA } from "@/components/sections/CTA";
import { WhyProvenance } from "@/components/sections/WhyProvenance";
import { WhyWeWin } from "@/components/sections/WhyWeWin";
import { SovereigntyModel } from "@/components/sections/SovereigntyModel";
import { Vision } from "@/components/sections/Vision";
import { EcosystemDiagram } from "@/components/sections/EcosystemDiagram";
import { PersonaSelector } from "@/components/sections/PersonaSelector";
import { SocialProof } from "@/components/sections/SocialProof";

const Index = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [showPersonaSelector, setShowPersonaSelector] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    // Check for URL query parameter first
    const personaParam = searchParams.get("persona");
    if (personaParam === "ceo") {
      navigate("/for-founders", { replace: true });
      return;
    }

    // Check localStorage for stored preference
    const stored = localStorage.getItem("provenance-persona");
    if (stored) {
      try {
        const { persona, rememberChoice } = JSON.parse(stored);
        if (rememberChoice && persona === "ceo") {
          navigate("/for-founders", { replace: true });
          return;
        }
        // If persona is set (investor or any), skip the selector
        if (persona) {
          setIsChecking(false);
          return;
        }
        // If no valid persona, show selector
        setShowPersonaSelector(true);
        setIsChecking(false);
      } catch {
        // Invalid stored data, show selector
        setShowPersonaSelector(true);
        setIsChecking(false);
      }
    } else {
      // No stored preference, show selector
      setShowPersonaSelector(true);
      setIsChecking(false);
    }
  }, [navigate, searchParams]);

  const handleSelectInvestor = () => {
    setShowPersonaSelector(false);
  };

  // Don't render anything while checking to prevent flash
  if (isChecking) {
    return null;
  }

  return (
    <div className="min-h-screen bg-background">
      {showPersonaSelector ? (
        <PersonaSelector onSelectInvestor={handleSelectInvestor} />
      ) : (
        <>
          <ContextAwareNavbar />
          <main>
            <Hero />
            <Stats />
            <WhyProvenance />
            <WhyWeWin />
            <SocialProof />
            <EcosystemDiagram />
            <Pillars />
            <SovereigntyModel />
            <Vision />
            <HowItWorks />
            <CTA />
          </main>
          <Footer />
        </>
      )}
    </div>
  );
};

export default Index;
